import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { RouterPath } from './router-path';
export var DynamicRouterPath = /*#__PURE__*/function (_RouterPath) {
  _inherits(DynamicRouterPath, _RouterPath);

  var _super = _createSuper(DynamicRouterPath);

  function DynamicRouterPath(pathParams, path) {
    var _this;

    var isProtected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    _classCallCheck(this, DynamicRouterPath);

    _this = _super.call(this, path, isProtected);
    _this.pathParams = pathParams;
    _this.path = path;
    _this.isProtected = isProtected;
    return _this;
  }

  _createClass(DynamicRouterPath, null, [{
    key: "createWithDynamic",
    value: function createWithDynamic(pathParams, path) {
      return new DynamicRouterPath(pathParams, path);
    }
  }]);

  return DynamicRouterPath;
}(RouterPath);